import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['Empty pages you still have to fill in', 'A few new tracks a month, with no order between them', 'A monthly fee that never ends', "Often built around one method's certification", 'You still decide what to teach on Tuesday'];
const withIt = ['A class for every week of the year, in order', '300 pages of counted, cued blocks', 'Easy, hard and first-timer lanes for mixed rooms', 'One payment — no subscription, no certification required', 'Open the week and teach'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-white" data-id="element-299" data-mp="2980gt851zdbb">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-300" data-mp="2d8sr84pnvo96">
        <div className="text-center" data-id="element-301" data-mp="2d79a6bw6l96c">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-302" data-mp="30yeq0r24g1gn">
            Why this isn&apos;t another planner
          </p>
          <h2 id="vs-heading" className="mt-3 font-display font-semibold text-plum text-3xl sm:text-5xl" data-id="element-303" data-mp="35qo8xn4tk19f">
            Blank templates vs{' '}
            <span className="italic text-coral-deep" data-id="element-304" data-mp="1ohbfahqdxmmt">a mapped year</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-305" data-mp="235fzjq53667p">
            Most tools for barre instructors sell you organization or a feed of
            new songs. Organizing was never the hard part — knowing what to
            teach this week, and next week, and the week after that, was.
          </p>
        </div>

        {/* Two columns at every width — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-3xl border border-cream-dark" data-id="element-306" data-mp="2m4k5ur58tlvo">
          <div className="bg-cream px-3.5 py-4 sm:p-6" data-id="element-307" data-mp="2h4fpd14c4r5g">
            <h3 className="font-display text-base font-semibold text-ink-soft sm:text-xl" data-id="element-308" data-mp="2h2us33qmyu3w">
              A blank planner or a monthly choreo feed
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-309" data-mp="mry6e5qj4d6m">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-ink-soft sm:text-sm" data-id="element-310" data-mp="2mtxn9wx4hsfn">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-coral/15" data-id="element-311" data-mp="2vu40ristmset">
                    <XIcon className="h-2.5 w-2.5 text-coral-deep" aria-hidden="true" data-id="element-312" data-mp="30t75110z8ulq" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-plum px-3.5 py-4 text-white sm:p-6" data-id="element-313" data-mp="3fhtjz1mozkcf">
            <h3 className="font-display text-base font-semibold text-gold sm:text-xl" data-id="element-314" data-mp="3fimumdorutzu">
              52 Weeks of Barre
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-315" data-mp="3oij9xop9ugi8">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-316" data-mp="3ogotaml19ajy">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-317" data-mp="7hghzq3v8iht">
                    <CheckIcon className="h-2.5 w-2.5 text-gold-hover" aria-hidden="true" data-id="element-318" data-mp="2jf038i6ep7x" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}